<template>
  <tr>
    <td class="asd-btn-group">
      <button type="button" class="asd-btn-edit"
              title="Editovat uživatele"
              @click="$router.push({name: 'usersDetail', params: {id: user.id}})"
      >
        <i class="fas fa-pencil-alt"></i>
      </button>
    </td>
    <td v-if="user.enabled">
      <i class="fas fa-circle" style="color: Green"></i>
    </td>
    <td v-else>
      <i class="fas fa-times" style="color: OrangeRed"></i>
    </td>
    <td v-if="user.isApiUser" class="isApiUser" v-help.mouse="`Toto je speciální uživatel pro WORKFLOW. Doporučujeme jej needitovat.`">
      <i class="fas fa-exchange-alt"></i>
      {{ user.username }}
    </td>
    <td v-else>
      {{ user.username }}
    </td>
    <td>
      {{ user.name }}
    </td>
    <td>
      {{ user.surname }}
    </td>
    <td class="groups-row">
      <span v-for="g in user.groups"
            :key="g.id"
      >
        {{ g.name }}
      </span>
    </td>
  </tr>
</template>

<script>
import _ from 'lodash'

const AUTHORIZATION = {
    edit_resources: {
        name: 'editovat zdroje',
    },
    edit_properties: {
        name: 'editovat vlastnosti',
    },
    edit_settings: {
        name: 'editovat nastavení',
    },
    edit_users: {
        name: 'editovat uživatele',
    },
}

export default {
    name: 'UserRow',
    components: {
    },
    props: {
        user: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
        }
    },
    computed: {
        authorizations() {
            return _.mapValues(AUTHORIZATION, (a, k) => {
                a.enabled = _.get(this.user.settings, `authorization.${k}`, false)
                return a
            })
        },
    },
    mounted() {
        if (!_.isPlainObject(_.get(this.user, 'settings'))) {
            this.$set(this.user, 'settings', {
                authorization: {},
            })
        }
        if (!_.isPlainObject(_.get(this.user, 'settings.authorization'))) {
            this.$set(this.user.settings, 'authorization', {})
        }
    },
    methods: {
        // toggleAuth(key) {
        //     if (_.get(this.user, `settings.authorization.${key}`, false)) {
        //         this.$set(this.user.settings.authorization, `${key}`, false)
        //     } else {
        //         this.$set(this.user.settings.authorization, `${key}`, true)
        //     }
        //     this.$emit('input', this.user)
        // },
    },
}
</script>

<style lang="scss" scoped>
.groups-row {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
}
.isApiUser {
    font-style: italic;
    color: magenta;
}
</style>

